export default __webpack_public_path__ + "static/media/icon_search.6a172f6c.svg";